import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { Wifi } from "lucide-react";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="mt-24 bg-slate-900 text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 font-bold text-white text-lg">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-[#2563EB]">
              <Wifi className="w-5 h-5 rotate-90" />
            </span>
            NFC Avis Pro
          </div>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">{t.home.disclaimer}</p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">{t.footer.about}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/a-propos" className="hover:text-white">{t.nav.about}</Link></li>
            <li><Link to="/fonctionnement" className="hover:text-white">{t.nav.how}</Link></li>
            <li><Link to="/faq" className="hover:text-white">{t.nav.faq}</Link></li>
            <li><Link to="/suivi" className="hover:text-white">{t.nav.track}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">{t.footer.legal}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/politique/expedition" className="hover:text-white">{t.legal.shipping.t}</Link></li>
            <li><Link to="/politique/retour" className="hover:text-white">{t.legal.refund.t}</Link></li>
            <li><Link to="/politique/confidentialite" className="hover:text-white">{t.legal.privacy.t}</Link></li>
            <li><Link to="/politique/conditions" className="hover:text-white">{t.legal.terms.t}</Link></li>
            <li><Link to="/politique/temoins" className="hover:text-white">{t.legal.cookies.t}</Link></li>
            <li><Link to="/politique/non-affiliation" className="hover:text-white">{t.legal.disclaimer.t}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">{t.footer.contact}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="hover:text-white">{t.nav.contact}</Link></li>
            <li><a href="mailto:contact@nfcavispro.com" className="hover:text-white">contact@nfcavispro.com</a></li>
            <li><Link to="/admin/login" className="text-slate-500 hover:text-white text-xs">{t.nav.admin}</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800 py-6 text-center text-xs text-slate-400">
        © {year} NFC Avis Pro. {t.footer.rights}. · {t.footer.made}
      </div>
    </footer>
  );
};

export default Footer;
